module.exports = __webpack_public_path__ + "assets/images/pdf/PI/0007.jpg";